import React from "react";
import { TbCalendarClock } from "react-icons/tb";
function GridOverlay4() {
  return (
    <div className="relative h-56 w-72  flex items-center justify-center bg-gray-100">
      {/* Grid Container */}
      <div className="grid grid-cols-2 h-56 w-72 ">
        {/* Grid Items */}
        <div className="bg-white md:bg-customAqua600 lg:bg-customAqua600 h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
      </div>

      {/* Overlay Div */}
      <div className="absolute p-4 z-10 w-full h-full  rounded-[40px] md:rounded-ss-[40px] lg:rounded-ss-[40px] bg-customAqua600 md:bg-white lg:bg-white  flex flex-col justify-around text-white">
        <TbCalendarClock className="w-12 h-12 text-customAqua100 " />
        <p className="text-lg font-semibold text-white lg:text-customAqua600 md:text-customAqua600 ">
          Facilités de réservation
        </p>
        <p className="font-normal text-sm text-white lg:text-customAqua600 md:text-customAqua600 ">
          Nous vous conseillons volontiers sur la base d'un projet ou dans le
          cadre d'un accord permanent.
        </p>
      </div>
    </div>
  );
}

export default GridOverlay4;
